import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Report } from '../../../models/report.model';
import { PTextareaComponent } from '../../../../shared/design-system/atoms/p-textarea/p-textarea.component';

@Component({
  selector: 'app-definitions-edit-mode',
  standalone: true,
  imports: [PTextareaComponent, ReactiveFormsModule],
  templateUrl: './definitions-edit-mode.component.html',
  styleUrl: './definitions-edit-mode.component.scss',
})
export class DefinitionsEditModeComponent {
  @Input() definitions!: Report.Definitions;

  @Output() definitionsChanged = new EventEmitter<Report.Definitions>();

  newDefinitions!: Report.Definitions;

  definitionsForm = new FormGroup({
    content: new FormControl(''),
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['definitions']) {
      this.definitionsForm.controls.content.setValue(this.definitions.content);
    }
  }

  onContentChanged($event: Event) {
    const value = ($event.target as HTMLInputElement).value;
    this.newDefinitions = {
      ...this.newDefinitions,
      content: value,
    };
    this.definitionsChanged.emit(this.newDefinitions);
  }
}
